import { useEffect } from 'react';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

const useAxiosInterceptor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response: AxiosResponse) => response,
      (error: AxiosError) => {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
        // Rechazamos la promesa para que las funciones llamantes puedan manejar el error correctamente
        return Promise.reject(error);
      }
    );

    return () => {
      // Limpiamos el interceptor cuando el componente se desmonte
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);
};

export default useAxiosInterceptor;
